import { TicketType } from "../../model/domain/Entity";
import { TicketCutoffTypeEnum } from "../../enum/cutoff-type.enum";

export class TicketCutoffDefaultType {
  id = 0;
  ticketTypeId: TicketType = null;
  cutoffType: string = null;
  timeLimit: Date = null;

  accountManagerId: number = null;
  fundId: number = null;

  dateTimeLimit: Date;

  isActive: boolean;
}

export enum TicketCutoffOperationType {
  Default = 1,
  Exception = 2,
}

export class TicketCutoffCreate {
  cutoffOperationType: TicketCutoffOperationType = null;
  ticketCutoffType: TicketCutoffTypeEnum = null;
  timeLimit: string = null;
  selectedAccountManagerFundList: SelectedAccountManagerFund[];
  justificative: string = null;
}

export class SelectedAccountManagerFund {
  accountManagerId: number = null;
  fundList: number[] = null;

  defaultTimeLimit: Date;
}

export class TicketCutoffException {
  id = 0;
  ticketCutoffDefaultId: TicketType = null;
  timeLimit: Date = null;
  justificative: string = null;
}
export class TicketCutoffDefault {
  id = 0;
  ticketCutoffDefaultId: TicketType = null;
  timeLimit: Date = null;
  justificative: string = null;
}

export class TicketCutoffExceptionModel {
  ticketCutoffType: TicketCutoffTypeEnum = null;
  timeLimit: string = null;
  selectedAccountManagerFundList: SelectedAccountManagerFund[] = [];
  justificative: string = null;
}
export class TicketCutoffDefaultModel {
  ticketCutoffType: TicketCutoffTypeEnum = null;
  timeLimit: string = null;
  selectedAccountManagerFundList: SelectedAccountManagerFund[] = [];
  justificative: string = null;
}

export class TicketCutoffPermission {
  ticketId: number = null;
  isAllowed: boolean = null;
  timeLimit: Date = null;
}

export class TicketCutoffTicketPermission {
  ticketCutoffTypeId: number;
  ticketId: number;
  accountManagerId: number;
  fundId: number;
}

export class TicketCutoffHistory {
  id = 0;
  ticketCutoffType: TicketCutoffType = null;
  creationDate: string = null;
  creationUser: string = null;
  timeLimit: Date = null;
  justificative: string = null;

  accountManagerId: number = null;
  fundId: number = null;

  accountManagerName: string = null;
  fundName: string = null;

  dateTimeLimit: Date;
}

export class TicketCutoffType {
  id: number = null;
  description: string = null;
}

export class TicketCutoffResume {
  ticketCutoffTypeId: number;
  ticketCutoffType: string;
  ticketCutoffDefaultId: number;
  ticketCutoffExceptionId: number;
  accountManagerId: number;
  fundId: number;

  defaultLimitTime: Date;
  currentLimitTime: Date;

  dateDefaultLimitTime: Date;
  dateCurrentLimitTime: Date;

  hasAccountManagerFundDefault: boolean;

  accountManagerName: string;
  fundName: string;
}
